module.exports = __webpack_public_path__ + "assets/images/historic-funds-text_3448af7e2eb184d870e895c6ab8e0b82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/historic-funds-text.png
// module id = 69
// module chunks = 0